function mouseSet(cursorSetting) {
  if (cursorSetting && cursorSetting.type === 'default') {
    document.documentElement.style.setProperty(`--defaultCursorURL`, `url('')`);
    document.documentElement.style.setProperty(`--hoverCursorURL`, `url('')`);
  } else if (cursorSetting) {
    document.documentElement.style.setProperty(
      `--defaultCursorURL`,
      cursorSetting.defaultImgURL
        ? `url('${cursorSetting.defaultImgURL}')`
        : `url('')`,
    );
    document.documentElement.style.setProperty(
      `--hoverCursorURL`,
      cursorSetting.hoverImgURL
        ? `url('${cursorSetting.hoverImgURL}')`
        : `url('')`,
    );
  }
}

export default mouseSet;
